import { useEffect, useRef } from 'react';

import io from 'socket.io-client';

import { useAuth } from '.';
import { BASE_URL } from 'consts';

const createSocket = (namespace, query, actions, token) => {
  const socket = io(`${BASE_URL}/${namespace}`, {
    transports: ['websocket'],
    auth: { token },
    query,
  });

  if (typeof actions === 'object') {
    for (const key in actions) {
      socket.on(key, actions[key]);
    }
  }

  return socket;
};

const useSocket = (namespace, params, actions) => {
  const { token } = useAuth();
  const socket = useRef();

  if (!socket.current) {
    socket.current = createSocket(namespace, params, actions, token);
  }

  useEffect(
    () => () => {
      socket.current.close();
    },
    []
  );

  return socket.current;
};

export default useSocket;
